import React from "react";
import { Check, Close } from "mosaic-react-icons";
import { SovosBox, SovosIconButton, SovosTypography } from "mosaic-react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const SuggestedFixesStatTile = ({
    hint,
    onAcceptAll,
    onRejectAll,
    showActions = false,
    value = 0,
}) => {
    const { i18n } = useGlobalValue();

    return (
        <SovosBox
            sx={{
                bgcolor: "background.paper",
                border: "1px solid",
                borderColor: "divider",
                borderBottom: "4px solid",
                borderBottomColor: "warning.main",
                borderRadius: 1,
                display: "flex",
                flex: 1,
                flexDirection: "column",
                gap: 0.25,
                minWidth: 140,
                p: 1.5,
            }}
        >
            <SovosTypography sx={{ color: "text.secondary" }} variant="caption">
                {i18n`Suggested fixes`}
            </SovosTypography>
            <SovosBox
                sx={{
                    alignItems: "center",
                    display: "flex",
                    gap: 1,
                    justifyContent: "space-between",
                }}
            >
                <SovosTypography sx={{ fontWeight: 700 }} variant="h6">
                    {value}
                </SovosTypography>
                {showActions && (
                    <SovosBox sx={{ alignItems: "center", display: "flex", gap: 0.5 }}>
                        <SovosIconButton
                            aria-label={i18n`Reject all suggested fixes`}
                            onClick={onRejectAll}
                            size="small"
                            tooltipText={i18n`Reject all`}
                        >
                            <Close sx={{ color: "error.main", fontSize: 20 }} />
                        </SovosIconButton>
                        <SovosIconButton
                            aria-label={i18n`Accept all suggested fixes`}
                            onClick={onAcceptAll}
                            size="small"
                            tooltipText={i18n`Accept all`}
                        >
                            <Check sx={{ color: "success.main", fontSize: 20 }} />
                        </SovosIconButton>
                    </SovosBox>
                )}
            </SovosBox>
            {hint && (
                <SovosTypography sx={{ color: "text.disabled" }} variant="caption">
                    {hint}
                </SovosTypography>
            )}
        </SovosBox>
    );
};

export default SuggestedFixesStatTile;
